import { render } from "./PaymentModal.vue?vue&type=template&id=7afb517b&scoped=true"
import script from "./PaymentModal.vue?vue&type=script&lang=js"
export * from "./PaymentModal.vue?vue&type=script&lang=js"

import "./PaymentModal.vue?vue&type=style&index=0&id=7afb517b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afb517b"]])

export default __exports__